export default __webpack_public_path__ + "static/media/sos-dia-02-11.a6aaf9c8.webp";